import React from "react";
import {benefitService} from "../jwt/_services/promotions/benefitService";

export const benefitProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await benefitService.getAll();

        return listItems.map((itemData) => {
            const { id, code, icon } = itemData
            let show = code != null && code !== "" ? code : "Sin codigo";
            return (
                {
                    id: id,
                    value: show,
                    icon: icon,
                    label: <div><label>{show}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await benefitService.getItem(id);
        let show = item.code != null && item.code !== "" ? item.code : "Sin codigo";
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}